function wm_progress_bar() {
    const progressBar = document.querySelector('[data-progress]');

    if (!progressBar) {
        return;
    }

    const items = document.querySelectorAll(progressBar.dataset.progress);

    if (!items) {
        return;
    }

    const totalItems = items.length;

    const options = {
      root: null,
      rootMargin: '0px 0px -90% 0px',
      threshold: 0
    };

    let currentActiveIndex = 0;

    const callback = (entries) => {
        entries.forEach(entry => {
            const itemIndex = Array.from(items).indexOf(entry.target);

            if (entry.isIntersecting) {
              currentActiveIndex = itemIndex;
            } else if (!entry.isIntersecting && itemIndex === currentActiveIndex && entry.boundingClientRect.top < 0) {
              currentActiveIndex = Math.min(itemIndex + 1, totalItems - 1);
            }
          });

          const progressPercent = ((currentActiveIndex + 1) / totalItems) * 100;

          progressBar.style.setProperty('--progress', `${progressPercent}%`);
    };

    const observer = new IntersectionObserver(callback, options);
    items.forEach(item => observer.observe(item));
}

jQuery(document).ready(function(){

    wm_progress_bar();

});
